/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { useRef, useCallback, useMemo } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Select from '../../../../components/Select';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import { ArrayFilters } from '../../../../interfaces/ticket';
import { Container } from './styles';

interface FiltersModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleApplyFilter(filters: any): void;
  filters: ArrayFilters;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  handleClose,
  handleApplyFilter,
  show,
  title,
  filters,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const filtersObject = useMemo(() => {
    const newObj = filters.filters.reduce(
      (key, name) => Object.assign(key, name),
      {},
    );
    return newObj;
  }, [filters]);

  const associadoOptions = [
    { value: '', label: 'Todos' },
    { value: 'S', label: 'Cartão associado' },
    { value: 'N', label: 'Cartão não associado' },
  ];

  const saldoOptions = [
    { value: '', label: 'Todos' },
    { value: 'S', label: 'Possui saldo' },
    { value: 'N', label: 'Não possui saldo' },
  ];

  const statusOptions = [
    { value: '', label: 'Todos' },
    { value: 'A', label: 'Ativo' },
    // { value: 'I', label: 'Inativo' },
    { value: 'B', label: 'Bloqueado' },
  ];

  const handleSubmit = useCallback((data: any) => {
    handleApplyFilter(data);
    console.log(data);
    localStorage.setItem('DataFilter', JSON.stringify(data));
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <Form ref={formTableRef} onSubmit={handleSubmit}>
          <Select
            defaultValue={
              filtersObject['link-employees']
                ? {
                    value: filtersObject['link-employees'],
                    label: 'Cartão Associado',
                  }
                : { value: '', label: 'Todos' }
            }
            name="associado"
            label="Cartões"
            placeholder="Selecione uma opção"
            options={associadoOptions}
          />
          <Select
            defaultValue={
              filtersObject?.balance
                ? {
                    value: filtersObject?.balance,
                    label: 'Possui saldo',
                  }
                : { value: '', label: 'Todos' }
            }
            name="saldo"
            label="Saldo"
            placeholder="Selecione a opção de saldo"
            options={saldoOptions}
          />
          <Select
            defaultValue={
              filtersObject?.status === 'A'
                ? {
                    value: filtersObject?.status,
                    label: 'Ativo',
                  }
                : filtersObject?.status === 'I'
                ? {
                    value: filtersObject?.status,
                    label: 'Inativo',
                  }
                : filtersObject?.status === 'B'
                ? {
                    value: filtersObject?.status,
                    label: 'Bloqueado',
                  }
                : { value: '', label: 'Todos' }
            }
            name="status"
            label="Status"
            placeholder="Selecione o status"
            options={statusOptions}
          />
          <div className="buttonsContainer">
            <Button color="orange" padding="1" type="submit">
              Aplicar Filtros
            </Button>
          </div>
        </Form>
      </Modal>
    </Container>
  );
};

export default FiltersModal;
